
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("736YY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $73fea88604ccd05b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b69e4602c3c1878109c2ce1bcc3a020>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $jz9js = parcelRequire("jz9js");

var $dh538 = parcelRequire("dh538");

var $4CeRR = parcelRequire("4CeRR");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $73fea88604ccd05b$var$Problem16Icon = ({ label: label, testId: testId })=>{
    if ((0, $dh538.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4CeRR.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4CeRR.default), {
        label: label,
        testId: testId
    });
};
$73fea88604ccd05b$var$Problem16Icon.displayName = 'Problem16Icon';
var $73fea88604ccd05b$export$2e2bcd8739ae039 = $73fea88604ccd05b$var$Problem16Icon;

});
parcelRegister("jz9js", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b0e283b3a840bc3b4c203e922f72a6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3e88288e5c7477c$var$_react = $e3e88288e5c7477c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $e3e88288e5c7477c$var$_baseNew = $e3e88288e5c7477c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e3e88288e5c7477c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3e88288e5c7477c$var$ProblemIcon = (props)=>/*#__PURE__*/ $e3e88288e5c7477c$var$_react.default.createElement($e3e88288e5c7477c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m3.964 2.904 9.132 9.132a6.501 6.501 0 0 0-9.132-9.132m8.072 10.192L2.904 3.964a6.501 6.501 0 0 0 9.132 9.132M2.343 2.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 2.343 2.343" clip-rule="evenodd"/>`
    }, props));
$e3e88288e5c7477c$var$ProblemIcon.displayName = 'ProblemIcon';
var $e3e88288e5c7477c$var$_default = module.exports.default = $e3e88288e5c7477c$var$ProblemIcon;

});

parcelRegister("4CeRR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f196733000e2e60$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a2258325f093d634d77334f2165e7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5DTTe = parcelRequire("5DTTe");
const $3f196733000e2e60$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5DTTe.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$3f196733000e2e60$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f196733000e2e60$export$2e2bcd8739ae039 = $3f196733000e2e60$var$Problem16Icon;

});



//# sourceMappingURL=16.f54526f0.js.map
